<div class="wrapper" (click)="navigate()">
    <div class="session">
        <div class="image">
            <img width="6rem" height="6rem" class="icon" src="./assets/img/dashboard/blocked-accounts.svg" />
            <div class="middle">
                <div class="text">Click to View</div>
            </div>
        </div>
    </div>
</div>
